import timestampValue from '../../../Timestamp/lib/value'

export default ({ formikProps }) =>
  timestampValue({ formikProps }) ? 'condition.termOne.' : ''
